// custom-bundle.js: Combined custom JS for performance optimization

// --- debounce helper (copied from global.js for safety) ---
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// --- pubsub.js ---
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

// --- search-form.js ---
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// --- Category Grid Carousel Arrow Scroll (Desktop & Mobile) ---
document.addEventListener('DOMContentLoaded', function () {
  var gridContainers = document.querySelectorAll('.category-grid__container');
  gridContainers.forEach(function(container) {
    var wrapper = container.querySelector('.category-grid__wrapper');
    // Desktop buttons
    var prevBtnDesktop = container.querySelector('.category-grid__nav--prev.desktop-only');
    var nextBtnDesktop = container.querySelector('.category-grid__nav--next.desktop-only');
    // Mobile buttons
    var prevBtnMobile = container.querySelector('.category-grid__nav-group-mobile .category-grid__nav--prev');
    var nextBtnMobile = container.querySelector('.category-grid__nav-group-mobile .category-grid__nav--next');
    if (!wrapper) return;

    var getCardWidth = function() {
      var card = wrapper.querySelector('.category-grid__item');
      return card ? card.offsetWidth + parseInt(getComputedStyle(wrapper).gap || 0) : 300;
    };

    if (prevBtnDesktop) {
      prevBtnDesktop.addEventListener('click', function() {
        wrapper.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtnDesktop) {
      nextBtnDesktop.addEventListener('click', function() {
        wrapper.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    }
    if (prevBtnMobile) {
      prevBtnMobile.addEventListener('click', function() {
        wrapper.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtnMobile) {
      nextBtnMobile.addEventListener('click', function() {
        wrapper.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    }
  });
}); 